<div class="section mt-64">
  <div class="section-content">
    <div class="mb-24">
      <nz-skeleton-element
        nzType="input"
        nzSize="small"
        style="width: 30%"
        [nzActive]="true"
      ></nz-skeleton-element>
    </div>

    <div class="mb-24">
      <nz-skeleton-element
        nzType="input"
        nzSize="default"
        style="width: 70%"
        [nzActive]="true"
      ></nz-skeleton-element>
    </div>

    <nz-skeleton
      [nzActive]="true"
      [nzTitle]="false"
      [nzParagraph]="{ rows: 5 }"
    ></nz-skeleton>
  </div>
</div>
